import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[stopPropagation]',
})
export class StopPropagationDirective implements OnDestroy {
  @Input() public stopEvent = 'click';

  private dispose;
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
    this.dispose = this.renderer.listen(
      this.elementRef.nativeElement,
      this.stopEvent,
      (e) => {
        e.stopPropagation();
      }
    );
  }
  public ngOnDestroy(): void {
    if (this.dispose) {
      this.dispose();
    }
  }
}
